import { TDdpMedia } from "@/shared/types"
import { HTMLAttributes } from "react"
import { EmptyImage } from "./EmptyImage";

export function DdpImage(props: HTMLAttributes<HTMLPictureElement> & {
    image: Array<TDdpMedia> | TDdpMedia
}) {
    const { image: _image, ...rest } = props
    if (!_image) return <EmptyImage {...rest} />;
    const image = Array.isArray(_image) ? _image[0] : _image;
    if (!image.imageS && !image.mediaS) return <EmptyImage {...rest} />;
    const mediaS = image.imageS ?? image.mediaS
    const mediaM = image.imageM ?? image.mediaM ?? mediaS;
    const mediaL = image.imageL ?? image.mediaL ?? mediaM;

    return (
        <picture >
            <source srcSet={mediaL.url + '?type=large'} media="(min-width: 1024px)" />
            <source srcSet={mediaM.url + '?type=medium'} media="(min-width: 744px)" />
            <img src={mediaS.url} alt={image.altText} className="object-cover w-full h-full" {...rest} />
        </picture>
    )
}